<template>
  <div class="pwc-basic-info">
    <v-layout row wrap>
      <v-flex class="pwc-info-cover" xs12 md5>
        <!-- <v-img
          contain
          :aspect-ratio="1.69"
          :src="event.detail.coverUrl"
        /> -->
      <van-image :src="event.detail.coverUrl" width="100%" height="100%" fit="contain" style="position: relative;padding-top: 22px;">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      </v-flex>
      <v-flex class="pwc-info-title" xs12 md7>
        <v-card flat>
          <v-card-title class="pwc-title-main">
            {{ event.detail.eventName }} - {{ event.detail.subject }}
          </v-card-title>
          <v-card-text class="pwc-title-icons">
            <p><v-icon>fas fa-calendar-alt</v-icon>&nbsp;&nbsp;&nbsp;(UTC+8:00) {{ event.detail.dateForPrint }}</p>
            <p><v-icon>fas fa-user-friends</v-icon>&nbsp;&nbsp;&nbsp;{{ event.detail.maxParticipateCount }}人</p>
            <p><v-icon>fas fa-map-marked-alt</v-icon>&nbsp;&nbsp;&nbsp;{{ event.detail.location }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <div
        v-if="!event.isRegisted && !event.hasSubmit && !event.eventEnd"
        class="pwc-event-action pwc-regieter-event"
        @click="event.handleRegister(true)"
      >{{ event.cRegisterText }}</div>
      <van-button v-else class="pwc-event-action pwc-regieter-event" @click="event.handleRegister" :disabled="event.eventEnd">{{ event.cRegisterText }}</van-button>
    </v-layout>
  </div>
</template>

	<script>
  import {Image, Loading} from 'vant'
  export default {
    components: {
      VanImage: Image,
      VanLoading: Loading,
  },
    inject: ['event']
  }
 </script>
<style lang="scss" scoped>
.pwc-basic-info {
    margin:auto;
    max-width: 960px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
    // border-radius: 8px;
    border: solid 1px #eeeeee;
    margin-top: 30px;
    padding-bottom: 40px;
    .pwc-info-cover {
      position: relative;
      left: 10px;
    }
    @media all and (max-width: 960px)  {
        .pwc-info-cover {
            margin-left: 0;
            margin-top: 0;
        }
    }
    .pwc-info-title {
        padding-left: 20px;
        .pwc-title-main {
            font-family: Microsoft Yahei;
            font-size: 24px;
            line-height: 32px;
        }
        .pwc-title-icons {
          p {
            font-size: 14px;
          }
          i {
            color: #d04a02;
          }
        }
    }
    @media all and (max-width: 960px) {
        .pwc-info-title {
          padding-left: 0;
        }
    }
    .pwc-event-action {
        height: 38px;
        margin-top: 20px;
        padding-left: 18px;
        padding-right: 18px;
        font-size: 16px;
        color: #fff;
        line-height: 38px;
        border-radius: 2px;
        text-align: center;
        font-family: "Microsoft YaHei";
        cursor: pointer;
        font-weight: 500;
        &.pwc-regieter-event {
            background-color: #d04a02;
        }
        &.pwc-event-end {
            background-color: #b5b5b5;
        }
    }
    @media all and (max-width: 960px)  {
        .pwc-event-action {
            min-width: 260px;
        }
    }
}
</style>

<style lang="scss">
.pwc-youplus-logo {
  margin-left: 5px !important;
}
.pwc-basic-info {
    padding-bottom: 40px;
    .pwc-info-cover {
        .v-image__image {
            border-radius: 15%;
        }
    }
    @media all and (max-width: 960px)  {
        .pwc-info-cover {
            .v-image__image {
                border-radius: 0;
            }
        }
    }
}
.van-image__error, .van-image__img, .van-image__loading {
    border-radius: 15%;
}
</style>
